import axios, { AxiosResponse } from 'axios'

import { RawReservationCreateResponse } from '@/api/manual_types'

import {
  ReservationCreate,
  ReservationDetailedRead,
  ReservationGuestInfoWrite,
  ReservationGuestModify,
  ReservationId,
} from '@generated/types'

const BASE_URL = '/api/reservation'

export default {
  async reserve(data: ReservationCreate): Promise<AxiosResponse<RawReservationCreateResponse>> {
    return axios.post(`${BASE_URL}/reserve/`, data)
  },

  async modify(
    reservationId: ReservationId,
    guest: ReservationGuestModify,
  ): Promise<AxiosResponse<ReservationDetailedRead>> {
    return axios.post(`${BASE_URL}/${reservationId}/modify/`, guest)
  },

  async updateGuestInfo(
    reservationId: ReservationId,
    data: ReservationGuestInfoWrite,
  ): Promise<AxiosResponse<ReservationDetailedRead>> {
    return axios.post(`${BASE_URL}/${reservationId}/guest-info/`, data)
  },

  async abandon(
    id: ReservationId,
    data?: Pick<ReservationGuestModify, 'reservation_key'>,
  ): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/${id}/abandon/`, data)
  },

  async fetchByIdAndKey(
    reservationId: ReservationId | string,
    reservationKey: string,
  ): Promise<AxiosResponse<any>> {
    return axios.get(`${BASE_URL}/${reservationId}/key/${reservationKey}/`)
  },
}
